// «Ваш прогресс» — design workspace screen (pwa-design@insights) on the
// engine progress counters. Code-only numbers (§2.8): no LLM, updated on
// each read.

import { useInsightsData } from '../model/useInsightsData'
import InsightsGate from './InsightsGate'
import InsightsTabBar from './InsightsTabBar'
import ProgressPage from './ProgressPage'

export default function Progress() {
  const insights = useInsightsData()
  return (
    <>
      <InsightsGate insights={insights}>
        {insights.data?.progress && <ProgressPage data={insights.data.progress} />}
      </InsightsGate>
      <InsightsTabBar />
    </>
  )
}
